import "core-js/stable";
import "regenerator-runtime/runtime";

import '../css/main.scss';
import '../css/libs/mmenu/mmenu-light.scss';

import 'jquery';
import './libs/jquery.autoresize';
import './libs/jquery.matchHeight-min';
import './libs/jquery.tablePagination';
import 'slick-carousel/slick/slick.min';

import './modules/xhr';
import './modules/menu';
import './modules/mobileMenu';
import './modules/cookieOverlay';
import './modules/countryMenu';
import './modules/scroll';
import './modules/slider';
import './modules/accordion';
import './modules/cardPopup';
import './modules/logoPopup';
import './modules/tabs';
import './modules/toggle';
import './modules/searchOverlay';
import './modules/search';
import './modules/googleMapsResponsive';
import './modules/loginOverlayPopup';
import './modules/heroAutoplayOnDesktop';
import './modules/legacy';
import './modules/i18nfixes';
import './modules/outbound';
import './modules/api';
import './modules/trainings';
import './modules/filterables';
import './modules/marketplace';
import './modules/eventCollections';
import './modules/toggleButton';
import initLocations from './modules/locations';
import './modules/forms';
import './modules/ajax';
import './modules/animatedTeasers';
import './modules/imagetips';
import './modules/videos';

// export function to access in tpl
const app = {
  initLocations,
};

export default app;
